import { CardContainer } from "./CardContainer"
import { CardStat } from "./CardComps"
import { Button, CircularProgress, IconButton, Stack } from "@mui/material"
import WarningIcon from "@mui/icons-material/Warning"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import { useSnackbar } from "notistack"
import { useState } from "react"
import { approveEscalate } from "../../api"
import dayjs from "dayjs"
import { downloadInvoice } from "./IncomeCard"

const ExpenseCard = ({ data, approve, reset }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const onAction = (type, action, id) => {
    setLoading(true)
    approveEscalate(type, action, id)
      .then(() => {
        enqueueSnackbar("Expense Status updated!", { variant: "success" })
        reset()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <CardContainer
      disableEditDelete
      SummaryContent={
        <>
          <CardStat label="Expense Head" value={data?.expenseHead_?.name} />
          <CardStat
            label="Expense Sub Head"
            value={data?.expenseSubHead_?.name}
          />
          <CardStat label="Beneficiary" value={data?.beneficiary?.name} />
          <CardStat
            label="Amount"
            value={`₹${parseFloat(data?.amount || 0).toFixed(2)}`}
          />
        </>
      }
      DetailsContent={
        <>
          <CardStat label="Mode" value={data?.modeOfPayment} />
          <CardStat label="Voucher Number" value={data?.invoiceNumber} />
          <CardStat label="Status" value={data?.status} />
          <CardStat
            label="Created"
            value={dayjs(data?.creationTimestamp).format(
              "MMM DD, YYYY | HH:mm A"
            )}
          />
        </>
      }
      ActionButtons={
        <>
          {approve && (
            <Stack spacing={1}>
              <Button onClick={() => onAction("expense", "escalate", data.id)}>
                {loading ? <CircularProgress /> : "Escalate"}
              </Button>
              <Button
                onClick={() => onAction("expense", "approve", data.id)}
                variant="contained"
              >
                {loading ? <CircularProgress /> : "Approve"}
              </Button>
            </Stack>
          )}
          {data?.billUrl == null ? (
            <WarningIcon color="warning" title="Invoice missing" />
          ) : (
            <IconButton onClick={() => downloadInvoice(data?.billUrl)}>
              <ReceiptLongIcon color="primary" title="Download Invoice" />
            </IconButton>
          )}
        </>
      }
    />
  )
}

export default ExpenseCard
